/**
 * @file Donor Story
 */

import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

/**
 * Donor Story component
 */
const vDonorStory = () => {
	const donorStories = document.querySelectorAll( '.v-donor-story' );

	if ( ! donorStories ) {
		return;
	}

	const ctas = [ ...donorStories ].map( ( story ) => story.querySelector( '.v-donor-story__cta' ) );

	gsap.registerPlugin( ScrollTrigger );

	[ ...donorStories ].forEach( ( story ) => {
		const inner       = story.querySelector( '.v-donor-story__inner' );
		const tweenVars   = {
			opacity:  1,
			duration: 1,
			ease:     'power1.inOut',
		};
		const triggerVars = {
			trigger:       inner,
			toggleActions: 'play none none reset',
		};

		gsap.fromTo( inner, { opacity: 0 }, {
			scrollTrigger: {
				start: 'top bottom-=10%',
				...triggerVars,
			},
			...tweenVars,
		} );
	} );

	if ( ! ctas ) {
		return;
	}

	[ ...ctas ].forEach( ( cta ) => {
		if ( ! cta ) {
			return;
		}

		const modalBorder = document.querySelector( cta.hash );
		const modalBg     = document.querySelector( `${ cta.hash } .v-story-modal__border` );
		const modalStory  = document.querySelector( `${ cta.hash } .v-story-modal__story-wrap` );

		/**
		 * Show Story modal
		 */
		const showModal = () => {
			if ( ! modalBorder.dataset.visible === 'false' ) {
				return;
			}

			gsap.timeline( {
				defaults: { ease: 'power1.inOut', duration: .75 },
				onStart:  () => {
					modalBorder.classList.remove( 'v-story-modal--hidden' );
					modalBorder.dataset.visible = 'true';

					modalBorder.focus();
				},
				onComplete: () => {
					[ modalBorder, modalBg, modalStory ].forEach( ( el ) => {
						el.removeAttribute( 'style' );
					} );
				},
			} )
				.fromTo( modalBorder, { opacity: 0 }, { opacity: 1 } )
				// .to( modalBorder, { opacity: 1 } )
				.fromTo( modalBg, {
					scale: .7,
					// opacity: 0.1,
				}, {
					scale: 1,
					// opacity: 1,
				}, '<5%' )
				.fromTo( modalStory, { opacity: 0 }, {
					opacity: 1,
				} );
		};

		cta.addEventListener( 'click', ( e ) => {
			e.preventDefault();

			showModal();
		} );
	} );
};

export default vDonorStory;
